import { createColumnHelper } from "@tanstack/react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";

import { convertDateToMonthDayYearFormat } from "../../../../shared";
import { processedMessageType } from "../../constants";

/**
 * Default date range for processed marketing attribution (excludes today).
 */
export const processedDatePreferenceUtility = () => {
  const startDate = new Date();
  startDate.setDate(startDate.getDate() + -7);
  startDate.setHours(0, 0, 0, 0);
  const endDate = new Date();
  endDate.setDate(endDate.getDate() - 1);
  endDate.setHours(23, 59, 59, 999);
  return { startDate, endDate };
};

//static headers for data table
const columnHelper = createColumnHelper();

//Table columns
export const processMarketingAttributionReportColumns = (
  setMarketingAttributionReportBodyModal
) => {
  return [
    columnHelper.accessor("restaurantTitle", {
      header: () => "Store",
    }),
    columnHelper.accessor("customerId", {
      header: () => "Id",
    }),
    columnHelper.accessor("customerName", {
      header: () => "Customer",
    }),
    columnHelper.accessor("customerEmail", {
      header: () => "Contact Info",
    }),
    columnHelper.accessor("messageType", {
      header: () => "Message Type",
      cell: ({ row: { original } }) =>
        processedMessageType[original.messageType],
    }),
    columnHelper.accessor("deliveryDate", {
      header: () => "Message Sent",
      cell: ({ row: { original } }) =>
        convertDateToMonthDayYearFormat(original.deliveryDate),
    }),
    columnHelper.accessor("orderPlacedDate", {
      header: "Order Placed",
      cell: ({ row: { original } }) =>
        convertDateToMonthDayYearFormat(original.orderPlacedDate),
    }),
    columnHelper.accessor("daysAfterMarketing", {
      header: "Days After Marketing",
      cell: ({ getValue, row: { original } }) => (
        <div className="d-flex justify-content-center align-items-center gap-3">
          <span>{getValue()}</span>
          <FontAwesomeIcon
            data-testid="edit-icon"
            icon={faEye}
            onClick={() => {
              setMarketingAttributionReportBodyModal(original);
            }}
          />
        </div>
      ),
    }),
  ];
};
